import { startLoading, stopLoading, LoadingTypes } from '@labrav/common'
import { updateAppAlert } from '../../../../common/modules/appAlert/actions'
import { RequestFailureMessage } from '../../../../common/utils/messagesContants'
import { AxiosResponse } from 'axios'
import { camelize } from 'casing'
import { fetchProductsList } from '../../../api/markeplace'
import { fetchAzurePublicProductsList } from '../../../api/azure'
import { getErrorMessages } from '../../../../common/utils/error'
import { errorLogger } from '../../../../common/utils/errorLogger'
import { AppDispatch, RootState } from '../../../../store'
import { CloudType } from '../../../../common/modules/types'
import { CloudMarketplace } from '@labrav/react-components/lib/@types/types/forms'
import { Product } from '../../productsListing/reducer'
import { returnMigrationProductListMicrosoft } from '../action'
import { isEmpty } from 'lodash'

export enum FlyoutMigrationProductsList {
  SET_FLYOUT_MIGRATION_PRODUCTS = 'SET_FLYOUT_MIGRATION_PRODUCTS',
}
export const getFlyOutMigrationProductsData =
  (partnerId: string, cloudType: CloudMarketplace) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch(startLoading(LoadingTypes.FLYOUT_PRODUCT_MIGRATION_PRODUCTS))
    try {
      const productList = getState()?.productsListing[cloudType].products?.rows
      const response = await getPublicProductListBasedOnCloud({
        partnerId,
        cloudType,
      })
      if (response) {
        const data = getResponseData({ response, cloudType, productList })
        await dispatch(setMigrationProductsData(data))
      }
    } catch (error) {
      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(
            error as AxiosResponse<ErrorResponse>
          ),
          messageType: 'ERROR',
          autoClose: false,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(error as Error)
    } finally {
      dispatch(stopLoading(LoadingTypes.FLYOUT_PRODUCT_MIGRATION_PRODUCTS))
    }
  }

export const setMigrationProductsData = (
  migrationProductsData: Record<string, unknown>
) => ({
  type: FlyoutMigrationProductsList.SET_FLYOUT_MIGRATION_PRODUCTS,
  payload: migrationProductsData,
})

export const getPublicProductListBasedOnCloud = async ({
  partnerId,
  cloudType,
}: {
  partnerId: string
  cloudType: CloudMarketplace
}) => {
  switch (cloudType) {
    case CloudType.AWS:
      return await fetchProductsList(
        partnerId,
        'product_dimensions,free_trial',
        CloudType.AWS,
        true
      )
    case CloudType.AZURE:
      return await fetchAzurePublicProductsList(partnerId)

    default:
      return
  }
}

const getResponseData = ({
  cloudType,
  productList,
  response,
}: {
  response: AxiosResponse<ErrorResponse>
  cloudType: CloudMarketplace
  productList?: Product[]
}) => {
  if (cloudType === CloudType.AWS) {
    return camelize(response?.data)
  }
  if (cloudType === CloudType.AZURE) {
    if (isEmpty(response?.data)) {
      return {
        products: {
          rows: [],
        },
      }
    }
    const sortedMigrationProducts = returnMigrationProductListMicrosoft({
      azureProducts: productList || [],
      migrationProducts: camelize(response?.data),
    })
    return {
      products: {
        rows: sortedMigrationProducts,
      },
    }
  }
  return camelize(response?.data)
}
